import type { MockMessage } from "@/dummy";

/**
 * The message the "unread messages" divider goes above: the FIRST genuinely unread incoming message,
 * i.e. the `count`-th agent message from the end. The visitor's own messages, system notices and the
 * thread seed (the slot text the BE inserts, already READ) never count as unread. Returns `null` when
 * nothing qualifies, or when the unread run reaches past the loaded page (the true first unread is not
 * loaded yet). With a seed present the history is loaded from the thread's start, so a count that
 * includes the seed is clamped to the real incoming messages.
 */
export function findUnreadAnchor(
  messages: readonly MockMessage[],
  count: number,
  seedId: string | null,
): string | null {
  if (count <= 0) return null;
  const incoming = messages.filter(
    (m) => m.direction === "OUTBOUND" && !m.system && m.id !== seedId,
  );
  if (incoming.length === 0) return null;
  const wanted = seedId ? Math.min(count, incoming.length) : count;
  if (incoming.length < wanted) return null;
  return incoming[incoming.length - wanted].id;
}
